// extracted by mini-css-extract-plugin
export default {"overflowYVisible":"AdministratorForm_overflowYVisible__cL7JY","modalContainer":"AdministratorForm_modalContainer__+hX83"};